import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { ROLLBACK_VERSION_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import {
  CHEK_STATUS_ROLLBACK_PLANS,
  CHEK_STATUS_ROLLBACK_PLANS_LOOP,
  CREATE_ROLLBACK_PLANS,
  LOAD_APPLICATION_HISTORY_VERSION_LIST,
  LOAD_ROLLBACK_PLANS,
} from './actions';

const initialState = {
  versionList: [],
  versionListMeta: {},
  loadingVersionList: false,
  rollbackPlan: {},
  loadingRollbackPlan: false,
  loadingStatusRollbackPlan: false,
  rollbackPlanList: [],
  loadingRollbackPlanList: false,
  rollbackPlanListMeta: {},
  loadingStatusLoopRollbackPlan: false,
};

const reducer = handleActions({
  ...createLoadParameterReducer(ROLLBACK_VERSION_MODULE + CREATE_ROLLBACK_PLANS, 'rollbackPlan', 'loadingRollbackPlan', {}),
  ...createOperationStateReducer(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS_LOOP, 'loadingStatusLoopRollbackPlan'),
  ...createLoadParameterReducer(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS, 'statusRollbackPlan', 'loadingStatusRollbackPlan'),
  ...createLoadListReducerWithBegin(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS, 'rollbackPlanList', 'loadingRollbackPlanList'),
  ...createLoadListReducerWithBegin(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST, 'versionList', 'loadingVersionList'),
}, initialState);

export default reducer;

export const getRollbackVersionData = createSelector(
  [state => state[ROLLBACK_VERSION_MODULE]],
  state => {
    const {
      versionList,
      versionListMeta,
      loadingVersionListList,
      rollbackPlan,
      loadingRollbackPlan,
      loadingStatusRollbackPlan,
      rollbackPlanList,
      loadingRollbackPlanList,
      rollbackPlanListMeta,
      loadingStatusLoopRollbackPlan,
    } = state;
    return {
      versionList,
      versionListMeta,
      loadingVersionListList,
      rollbackPlan,
      loadingRollbackPlan,
      loadingStatusRollbackPlan,
      rollbackPlanList,
      loadingRollbackPlanList,
      rollbackPlanListMeta,
      loadingStatusLoopRollbackPlan,
    };
  },
);
